export const TEAM = 'eprivacy'
export const SERVICE = 'cmp'
